import { EJEnterSlotBonusState } from "states/slotbonus/ej-enter-slot-bonus-state";
import { BlastworksClientEvent } from "../ClientController";

export class SocialEnterSlotBonusState extends EJEnterSlotBonusState {
    public onEnter(cascadeSkip?: boolean): void {
        this.stateMachine.dispatchClientEvent(BlastworksClientEvent.BONUS_START);
        super.onEnter(cascadeSkip);
    }
}